import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { 
  Users, Calendar, Video, MessageCircle, Briefcase, 
  Presentation, Sparkles, TrendingUp, Layout, Image as ImageIcon,
  CheckCircle, FileText, Play, Camera, Zap
} from 'lucide-react';
import { isAuthenticated, getUser } from '../lib/auth';
import SidebarNavigation from '../components/SidebarNavigation';

const Home = () => {
  const isAuth = isAuthenticated();
  const user = getUser();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Detect device type
    const checkDevice = () => {
      const width = window.innerWidth;
      setIsMobile(width < 768); // Mobile if less than 768px
    };

    checkDevice();
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  const allApps = [
    {
      name: 'Digi Connect',
      path: '/digi-connect',
      demoPath: '/profile/demo-user-12345',
      icon: <Users className="w-8 h-8 sm:w-10 sm:h-10" />,
      gradient: 'from-slate-900 to-slate-700',
      description: 'Network & Business Cards',
      image: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?w=600&q=80'
    },
    {
      name: 'Digi Meet',
      path: '/digi-meet',
      demoPath: '/digi-meet',
      icon: <Video className="w-8 h-8 sm:w-10 sm:h-10" />,
      gradient: 'from-blue-600 to-blue-800',
      description: 'Video Conferencing',
      image: 'https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?w=600&q=80'
    },
    {
      name: 'Digi Calendar',
      path: '/digi-calendar',
      demoPath: '/schedule/demo-user-12345',
      icon: <Calendar className="w-8 h-8 sm:w-10 sm:h-10" />,
      gradient: 'from-indigo-600 to-indigo-800',
      description: 'Meeting Scheduler',
      image: 'https://images.unsplash.com/photo-1506784983877-45594efa4cbe?w=600&q=80'
    },
    {
      name: 'Digi Community',
      path: '/community',
      demoPath: '/community',
      icon: <MessageCircle className="w-8 h-8 sm:w-10 sm:h-10" />,
      gradient: 'from-purple-600 to-purple-800',
      description: 'Q&A Forum',
      image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=600&q=80'
    },
    // {
    //   name: 'Digi Strategy',
    //   path: '/digi-strategy',
    //   demoPath: '/digi-strategy',
    //   icon: <TrendingUp className="w-8 h-8 sm:w-10 sm:h-10" />,
    //   gradient: 'from-orange-600 to-red-600',
    //   description: 'AI Business Strategy',
    //   image: 'https://images.unsplash.com/photo-1551434678-e076c223a692?w=600&q=80'
    // },
    {
      name: 'Digi CRM',
      path: '/crm-leads',
      demoPath: '/digi-crm',
      icon: <Briefcase className="w-8 h-8 sm:w-10 sm:h-10" />,
      gradient: 'from-green-600 to-emerald-700',
      description: 'Customer Manager',
      image: 'https://images.unsplash.com/photo-1553877522-43269d4ea984?w=600&q=80'
    },
    {
      name: 'Digi Website',
      path: '/website-builder',
      demoPath: '/website-builder',
      icon: <Layout className="w-8 h-8 sm:w-10 sm:h-10" />,
      gradient: 'from-amber-600 to-amber-800',
      description: 'Website Builder',
      image: 'https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?w=600&q=80'
    },
    {
      name: 'Quick Website',
      path: '/auto-website',
      demoPath: '/auto-website',
      icon: <Sparkles className="w-8 h-8 sm:w-10 sm:h-10" />,
      gradient: 'from-emerald-600 to-teal-600',
      description: 'Auto Website Generator',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&q=80'
    },
    {
      name: 'Digi Events',
      path: '/events',
      demoPath: '/events',
      icon: <Calendar className="w-8 h-8 sm:w-10 sm:h-10" />,
      gradient: 'from-violet-600 to-violet-800',
      description: 'Event Management',
      image: 'https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=600&q=80'
    },
    {
      name: 'Digi Presentor',
      path: '/presentor',
      demoPath: '/presentor',
      icon: <Presentation className="w-8 h-8 sm:w-10 sm:h-10" />,
      gradient: 'from-fuchsia-600 to-fuchsia-800',
      description: 'AI Scripts',
      image: 'https://images.unsplash.com/photo-1475721027785-f74eccf877e2?w=600&q=80'
    },
    {
      name: 'Community Videos',
      path: '/community-videos',
      demoPath: '/community-videos',
      icon: <Play className="w-8 h-8 sm:w-10 sm:h-10" />,
      gradient: 'from-pink-600 to-rose-600',
      description: 'Short Video Sharing',
      image: 'https://images.unsplash.com/photo-1584839401450-accbe1a8ef7b?w=600&q=80'
    },
    {
      name: 'Media Events',
      path: '/photo-video-events',
      demoPath: '/media-event/9abf261a-ec18-47ed-afc4-dd8259b19e72',
      icon: <Camera className="w-8 h-8 sm:w-10 sm:h-10" />,
      gradient: 'from-cyan-600 to-blue-600',
      description: 'Photo/Video Sharing',
      image: 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?w=600&q=80'
    },
    // {
    //   name: 'Photobooth',
    //   path: '/photobooth',
    //   demoPath: '/photobooth',
    //   icon: <Camera className="w-8 h-8 sm:w-10 sm:h-10" />,
    //   gradient: 'from-purple-600 to-pink-600',
    //   description: 'QR Photo Printing',
    //   image: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?w=600&q=80'
    // },
    // {
    //   name: 'HR Operations',
    //   path: '/hr-ops',
    //   demoPath: '/hr-ops',
    //   icon: <Briefcase className="w-8 h-8 sm:w-10 sm:h-10" />,
    //   gradient: 'from-indigo-600 to-blue-600',
    //   description: 'Manager Dashboard',
    //   image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&q=80'
    // },
    // {
    //   name: 'Digi Squad',
    //   path: '/digi-squad',
    //   demoPath: '/digi-squad',
    //   icon: <Zap className="w-8 h-8 sm:w-10 sm:h-10" />,
    //   gradient: 'from-amber-600 to-orange-600',
    //   description: 'Team Collaboration',
    //   image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=600&q=80'
    // },
    {
      name: 'DigiSlides Pro',
      path: '/digi-slides',
      demoPath: '/digi-slides',
      icon: <FileText className="w-8 h-8 sm:w-10 sm:h-10" />,
      gradient: 'from-purple-600 to-blue-600',
      description: 'AI Presentations',
      image: 'https://images.unsplash.com/photo-1542744094-3a31f272c490?w=600&q=80'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {isAuth && <SidebarNavigation />}

      {/* Hero Section */}
      {!isAuth && (
        <div 
          className="relative bg-cover bg-center py-16 sm:py-20 md:py-24 lg:py-32"
          style={{
            backgroundImage: `linear-gradient(rgba(15, 23, 42, 0.85), rgba(15, 23, 42, 0.75)), url('https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1920&q=80')`,
          }}
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center">
            <h1 
              className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight" 
              style={{fontFamily: 'Space Grotesk, sans-serif'}}
            >
              Your Complete Business Ecosystem
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-gray-200 mb-6 sm:mb-8 max-w-3xl mx-auto px-4">
              Everything you need to connect, collaborate, and grow your business
            </p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center px-4">
              <Link to="/auth" className="w-full sm:w-auto">
                <Button 
                  size="lg" 
                  className="w-full sm:w-auto bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white px-8 sm:px-10 py-5 sm:py-6 text-base sm:text-lg rounded-full shadow-2xl"
                >
                  Get Started Free →
                </Button>
              </Link>
              <Link to="/pricing" className="w-full sm:w-auto">
                <Button 
                  size="lg" 
                  variant="outline" 
                  className="w-full sm:w-auto bg-white text-slate-900 border-2 border-white hover:bg-gray-100 px-8 sm:px-10 py-5 sm:py-6 text-base sm:text-lg rounded-full"
                >
                  View Pricing
                </Button>
              </Link>
            </div>
          </div>
        </div>
      )}

      {/* Logged In Hero */}
      {isAuth && (
        <div className="bg-gradient-to-br from-slate-50 to-blue-50 py-8 sm:py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center">
            <h1 
              className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-2 sm:mb-3" 
              style={{fontFamily: 'Space Grotesk, sans-serif'}}
            >
              Welcome back, {user?.name}! 👋
            </h1>
            <p className="text-base sm:text-lg text-slate-600">
              Choose an app to get started
            </p>
          </div>
        </div>
      )}

      {/* Apps Grid - Device Optimized */}
      {isAuth && (
        <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 py-6 sm:py-8 md:py-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-5 md:gap-6">
            {allApps.map((app) => (
              <Link key={app.path} to={app.comingSoon ? '#' : app.path} className="block" onClick={(e) => app.comingSoon && e.preventDefault()}>
                <div className={`group relative bg-white rounded-xl sm:rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 border border-slate-200 hover:border-slate-400 h-full ${app.comingSoon ? 'opacity-75' : ''}`}>
                  {/* Coming Soon Badge */}
                  {app.comingSoon && (
                    <div className="absolute top-3 right-3 z-10 bg-yellow-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg">
                      Coming Soon
                    </div>
                  )}
                  
                  {/* Image Background */}
                  <div 
                    className="h-32 sm:h-36 md:h-40 bg-cover bg-center relative"
                    style={{ backgroundImage: `url(${app.image})` }}
                  >
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                    <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4">
                      <div className={`p-2.5 sm:p-3 bg-gradient-to-br ${app.gradient} rounded-lg sm:rounded-xl shadow-lg transform group-hover:scale-110 transition-transform`}>
                        <div className="text-white">
                          {app.icon}
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Content */}
                  <div className="p-4 sm:p-5">
                    <h3 
                      className="text-lg sm:text-xl font-bold text-slate-900 mb-1" 
                      style={{fontFamily: 'Space Grotesk, sans-serif'}}
                    >
                      {app.name}
                    </h3>
                    <p className="text-xs sm:text-sm text-slate-600">{app.description}</p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}

      {/* Demo Apps for Non-Logged Users */}
      {!isAuth && (
        <div className="py-12 sm:py-16 md:py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6">
            <div className="text-center mb-10 sm:mb-12 md:mb-16">
              <h2 
                className="text-2xl sm:text-3xl md:text-4xl font-bold text-slate-900 mb-3 sm:mb-4" 
                style={{fontFamily: 'Space Grotesk, sans-serif'}}
              >
                Try Our Apps - No Login Required
              </h2>
              <p className="text-base sm:text-lg text-slate-600 max-w-2xl mx-auto px-4">
                Explore all features with interactive demos
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 sm:gap-6">
              {allApps.filter(app => !app.comingSoon).map((app) => (
                <Link key={app.path} to={app.demoPath} className="block group">
                  <div className="bg-white rounded-xl sm:rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 border-2 border-slate-200 hover:border-blue-400 h-full">
                    <div 
                      className="h-40 sm:h-44 bg-cover bg-center relative"
                      style={{ backgroundImage: `url(${app.image})` }}
                    >
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                      <div className="absolute top-3 right-3 bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg">
                        Try Demo
                      </div>
                      <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4">
                        <div className={`p-2.5 sm:p-3 bg-gradient-to-br ${app.gradient} rounded-lg sm:rounded-xl shadow-lg transform group-hover:scale-110 transition-transform`}>
                          <div className="text-white">
                            {app.icon}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="p-5 sm:p-6">
                      <h3 
                        className="text-lg sm:text-xl font-semibold text-slate-900 mb-2" 
                        style={{fontFamily: 'Space Grotesk, sans-serif'}}
                      >
                        {app.name}
                      </h3>
                      <p className="text-sm text-slate-600 mb-3">{app.description}</p>
                      <span className="text-sm text-blue-600 font-semibold group-hover:text-blue-700">
                        Launch Demo →
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* CTA Section */}
      {!isAuth && (
        <div 
          className="relative bg-cover bg-center py-12 sm:py-16 md:py-20"
          style={{
            backgroundImage: `linear-gradient(rgba(59, 130, 246, 0.9), rgba(147, 51, 234, 0.9)), url('https://images.unsplash.com/photo-1557804506-669a67965ba0?w=1920&q=80')`,
          }}
        >
          <div className="max-w-4xl mx-auto text-center px-4 sm:px-6">
            <h2 
              className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-3 sm:mb-4" 
              style={{fontFamily: 'Space Grotesk, sans-serif'}}
            >
              Ready to Transform Your Business?
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-100 mb-6 sm:mb-8 max-w-2xl mx-auto">
              Join thousands of businesses using DigiDreamSolutions
            </p>
            <Link to="/auth">
              <Button 
                size="lg" 
                className="bg-white text-blue-600 hover:bg-gray-100 px-8 sm:px-10 py-5 sm:py-6 text-base sm:text-lg rounded-full shadow-2xl"
              >
                Start Your Free Trial →
              </Button>
            </Link>
            <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-8 mt-8 sm:mt-12 text-white text-sm sm:text-base">
              <div className="flex items-center justify-center gap-2">
                <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5" />
                <span>Free Forever Plan</span>
              </div>
              <div className="flex items-center justify-center gap-2">
                <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5" />
                <span>No Credit Card</span>
              </div>
              <div className="flex items-center justify-center gap-2">
                <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5" />
                <span>Cancel Anytime</span>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Founder Section */}
      <div className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-slate-50 to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-3 sm:mb-4" style={{fontFamily: 'Space Grotesk, sans-serif'}}>
              Meet the <span className="bg-gradient-to-r from-blue-600 to-purple-600 text-transparent bg-clip-text">Founder</span>
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
              Innovation meets passion to solve real business problems
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
            {/* Founder Info */}
            <div className="space-y-4 sm:space-y-6">
              <div>
                <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-2" style={{fontFamily: 'Space Grotesk, sans-serif'}}>
                  Akhil Gutta
                </h3>
                <p className="text-lg sm:text-xl text-blue-600 font-semibold mb-4">
                  Founder & CEO
                </p>
              </div>

              <div className="prose prose-sm sm:prose-base max-w-none">
                <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                  A young entrepreneur with a passion for innovative ideas, Akhil is dedicated to solving the real challenges faced by solopreneurs and small businesses. This vision gave birth to <span className="font-semibold text-blue-600">DigiDreamSolutions</span> – a comprehensive digital ecosystem designed to empower businesses.
                </p>
                
                <p className="text-gray-700 text-sm sm:text-base leading-relaxed mt-4">
                  But innovation doesn't stop at tech! Akhil is also a chocolatier and founder of <span className="font-semibold text-purple-600">potraitchocolate</span>, revolutionizing the events industry with live photo-printed chocolates, edible photo cards, and edible postcards. His unique creations bring a delicious twist to memorable moments.
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4">
                <div className="bg-white rounded-xl p-4 shadow-md border border-blue-100">
                  <div className="flex items-center gap-3 mb-2">
                    <Briefcase className="w-5 h-5 text-blue-600" />
                    <h4 className="font-semibold text-sm">DigiDreamSolutions</h4>
                  </div>
                  <p className="text-xs text-gray-600">Digital Business Ecosystem</p>
                </div>
                
                <div className="bg-white rounded-xl p-4 shadow-md border border-purple-100">
                  <div className="flex items-center gap-3 mb-2">
                    <Camera className="w-5 h-5 text-purple-600" />
                    <h4 className="font-semibold text-sm">potraitchocolate</h4>
                  </div>
                  <p className="text-xs text-gray-600">Edible Photo Innovations</p>
                </div>
              </div>

              <div className="flex flex-wrap gap-3 pt-4">
                <div className="flex items-center gap-2 bg-blue-50 px-4 py-2 rounded-full">
                  <Sparkles className="w-4 h-4 text-blue-600" />
                  <span className="text-xs sm:text-sm font-medium text-blue-900">Innovator</span>
                </div>
                <div className="flex items-center gap-2 bg-purple-50 px-4 py-2 rounded-full">
                  <TrendingUp className="w-4 h-4 text-purple-600" />
                  <span className="text-xs sm:text-sm font-medium text-purple-900">Entrepreneur</span>
                </div>
                <div className="flex items-center gap-2 bg-pink-50 px-4 py-2 rounded-full">
                  <Zap className="w-4 h-4 text-pink-600" />
                  <span className="text-xs sm:text-sm font-medium text-pink-900">Chocolatier</span>
                </div>
              </div>
            </div>

            {/* Founder Images */}
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="rounded-2xl overflow-hidden shadow-2xl transform hover:scale-105 transition-all duration-300 bg-gradient-to-br from-blue-600 to-purple-600">
                  <img 
                    src="/founder-akhil-1.jpg" 
                    alt="Akhil Gutta - Founder & CEO" 
                    className="w-full h-auto object-cover"
                  />
                </div>
              </div>
              
              <div className="space-y-4 mt-8">
                <div className="rounded-2xl overflow-hidden shadow-2xl transform hover:scale-105 transition-all duration-300 bg-gradient-to-br from-purple-600 to-pink-600">
                  <img 
                    src="/founder-akhil-2.jpg" 
                    alt="Akhil Gutta - Chocolatier & Innovator" 
                    className="w-full h-auto object-cover"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Vision Quote */}
          <div className="mt-12 sm:mt-16 text-center">
            <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8 md:p-10 max-w-4xl mx-auto border-t-4 border-blue-600">
              <div className="text-4xl sm:text-5xl text-blue-600 mb-4">"</div>
              <p className="text-lg sm:text-xl md:text-2xl font-medium text-gray-800 italic mb-4">
                Innovation is not just about creating something new; it's about solving real problems and making a meaningful impact on people's lives.
              </p>
              <p className="text-sm sm:text-base text-gray-600 font-semibold">— Akhil Gutta</p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-slate-900 text-white py-8 sm:py-10 md:py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 mb-6 sm:mb-8">
            <div className="col-span-2 sm:col-span-1">
              <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4" style={{fontFamily: 'Space Grotesk, sans-serif'}}>DigiDreamSolutions</h3>
              <p className="text-xs sm:text-sm text-gray-400">Complete business ecosystem</p>
            </div>
            <div>
              <h4 className="text-sm sm:text-base font-semibold mb-2 sm:mb-3">Products</h4>
              <ul className="space-y-1.5 sm:space-y-2 text-xs sm:text-sm text-gray-400">
                <li><Link to="/digi-connect" className="hover:text-white">Digi Connect</Link></li>
                <li><Link to="/digi-meet" className="hover:text-white">Digi Meet</Link></li>
                <li><Link to="/digi-strategy" className="hover:text-white">Digi Strategy</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm sm:text-base font-semibold mb-2 sm:mb-3">Company</h4>
              <ul className="space-y-1.5 sm:space-y-2 text-xs sm:text-sm text-gray-400">
                <li><Link to="/pricing" className="hover:text-white">Pricing</Link></li>
                <li><a href="#" className="hover:text-white">About</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm sm:text-base font-semibold mb-2 sm:mb-3">Legal</h4>
              <ul className="space-y-1.5 sm:space-y-2 text-xs sm:text-sm text-gray-400">
                <li><a href="#" className="hover:text-white">Privacy</a></li>
                <li><a href="#" className="hover:text-white">Terms</a></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-slate-800 pt-6 sm:pt-8 text-center text-xs sm:text-sm text-gray-400">
            <p>&copy; 2025 DigiDreamSolutions. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
